import _ from "lodash";
import { Nullable } from "../../../../../@types/util";

interface FormOption<TValue = string, TLabel = string> {
  value: TValue;
  label: TLabel;
  disabled?: boolean;
}

export const valueToFormOption = (
  value: Nullable<string>,
  formOptions?: FormOption[]
): FormOption | undefined => {
  if (!value) {
    return undefined;
  }
  const formOption = (formOptions ?? []).find(
    ({ value: optionValue }) => optionValue === value
  );
  return (
    formOption ?? {
      label: value,
      value,
    }
  );
};

export const formOptionToValue = (
  formOption?: Nullable<FormOption>
): string => {
  return formOption?.value ?? "";
};

export const formOptionsToSalesforcePicklistString = (
  formOptions?: Nullable<FormOption[]>
): string => {
  if (!formOptions || formOptions.length === 0) {
    return "";
  }
  return (formOptions || [])
    .map(({ value }) => value)
    .filter((x) => x)
    .join(";");
};

export const salesforcePicklistStringToFormOptions = (
  salesforcePicklistString: string | undefined,
  formOptions?: FormOption[]
): FormOption[] => {
  if (!_.isString(salesforcePicklistString)) {
    return [];
  }
  return salesforcePicklistString
    .split(";")
    .map((value) => {
      return valueToFormOption(value, formOptions);
    })
    .filter((option) => !_.isUndefined(option))
    .map((option) => option as FormOption);
};

export default FormOption;
